import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Button, Table, Form, Modal } from "react-bootstrap";

import "react-toastify/dist/ReactToastify.css";
import "react-activity/dist/library.css";
import { loader } from "../../../loader";
import { toast } from "react-toastify";
import { deleteData, getData, postData } from "../../../axios/apiInstanceHelper";
import { ENDPOINT } from "../../../axios/apiConfig";

let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
const rdLikeArray = [
  "56Ek4feL/1A8mZgIKQWEqg==",
  "bWmUjqX7J011   WUTYn9g==",
  "MXl8m36VZFYXpgFVz3Pg0g==",
  "HPW6EwQy6v8VrfnMsjz8tg==",
];

const Highlights = () => {
  const navigate = useNavigate();
  const isLikeRdAccount = rdLikeArray.includes(localStorage.getItem("user_id"));
  const isUSAPharmaAccount =
    localStorage?.getItem("account_type") === "USA_PHARMA" ? 1 : 0;

  const [actionStatus, setActionStatus] = useState("list");
  const [trigger, setTrigger] = useState(0);
  const [highlightData, setHighlightData] = useState({
    loading: false,
    error: false,
    data: [],
  });
  const [liveHighlightData, setLiveHighlightData] = useState([]);
  const [offlineHighlightData, setOfflineHighlightData] = useState([]);
  const [searchText, setSearchText] = useState("");


  useEffect(() => {
    loader("show");
    setHighlightData({ loading: true, error: false, data: [] });
    getData(ENDPOINT.GET_HIGHLIGHTS + "?page=1", {
        headers: {
          frontendid: localStorage.getItem("user_id"),
          Token: localStorage.getItem("user_id"),
          created_by: localStorage.getItem("user_id"),
        },
      })
      .then((res) => {
        if (res.status === 200)
          setHighlightData({
            loading: false,
            error: false,
            data: res.data.data.posts,
          });
        else setHighlightData({ loading: false, error: false, data: [] });
        loader("hide");
      })
      .catch((err) => {
        console.log("error while fetching the highlight data : ", err);
        setHighlightData({ loading: false, error: true, data: [] });
        loader("hide");
        toast.error("Failed to fetch the highlight data");
      });
  }, [trigger]);

  useEffect(() => {
    if (highlightData.data.length) {
      setLiveHighlightData([]);
      setOfflineHighlightData([]);
      let liveCount = 0;
      highlightData.data
        .sort((i1, i2) => i1.position - i2.position)
        .map((h) => {
          if (h.live_status) {
            liveCount++;
            setLiveHighlightData((prev) => [
              ...prev,
              { ...h, position: liveCount },
            ]);
          } else setOfflineHighlightData((prev) => [...prev, h]);
        });
    }
  }, [highlightData]);

  const submitHandler = (e) => {
    e.preventDefault();
  };

  const searchChange = (e) => {
  const value = e.target.value.toLowerCase();

  if (!value) {
    // reset to original data
    setTrigger((prev) => prev + 1);
    return;
  }

  const filtered = highlightData.data.filter((item) =>
    item.heading?.toLowerCase().includes(value)
  );

  let live = [];
  let offline = [];
  let liveCount = 0;

  filtered
    .sort((a, b) => a.position - b.position)
    .forEach((item) => {
      if (item.live_status) {
        liveCount++;
        live.push({ ...item, position: liveCount });
      } else {
        offline.push(item);
      }
    });

  setLiveHighlightData(live);
  setOfflineHighlightData(offline);
};

  return (
    <Col className="right-sidebar custom-change onesource-opition">
      <div className="custom-container">
        <div className="top-header sticky">
          <div className="page-title">
            <h2>Highlights</h2>
          </div>
          <div className="top-right-action">
            <div className="action-btn-add">
              <button
                type="button"
                className="btn-dashed btn btn-primary"
                onClick={() =>
                  navigate("/create-edit-highlight", {
                    state: {
                      type: "create",
                    },
                  })
                }
              >
                Create Highlight
                <img src="/componentAssets/images/add-icon.png" alt="icon" />
              </button>
            </div>
            <div className="action-btn-add">
              {actionStatus === "edit" ? (
                <Button
                  className="btn btn-outline-primary cancel"
                  onClick={(e) => setActionStatus("list")}
                >
                  Cancel
                </Button>
              ) : (
                <button
                  type="button"
                  className="btn-white btn btn-primary"
                  onClick={() => setActionStatus("edit")}
                  disabled={actionStatus === "delete"}
                >
                  Edit Highlight
                  <img
                    src="/componentAssets/images/edit-button.svg"
                    alt="icon"
                  />
                </button>
              )}
            </div>
            <div className="search-bar">
              <form className="d-flex" onSubmit={(e) => submitHandler(e)}>
                <input
                  className="form-control me-2"
                  type="text"
                  placeholder="Search by Highlight title"
                  aria-label="Search"
                  id="email_search"
                  onChange={(e) => searchChange(e)}
                />
                <button className="btn btn-outline" type="submit">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.82522 0 6.33325 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84132 12.6667 6.33328 12.6667C7.83992 12.6667 9.22325 12.136 10.3119 11.2547L14.8619 15.8047C14.9919 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33328 11.3333C3.57597 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57597 1.33331 6.33328 1.33331C9.0906 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09057 11.3333 6.33328 11.3333Z"
                      fill="#97B6CF"
                    />
                  </svg>
                </button>
              </form>
            </div>
            <div className="clear-search">
              {actionStatus === "delete" ? (
                <Button
                  className="btn btn-outline-primary cancel"
                  onClick={(e) => setActionStatus("list")}
                >
                  Cancel
                </Button>
              ) : (
                <button
                  className="btn btn-outline-primary"
                  onClick={(e) => setActionStatus("delete")}
                  disabled={actionStatus === "edit"}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.84 22.25H8.15989C7.3915 22.2389 6.65562 21.9381 6.09941 21.4079C5.5432 20.8776 5.20765 20.157 5.15985 19.39L4.24984 5.55C4.24518 5.44966 4.26045 5.34938 4.29478 5.25498C4.32911 5.16057 4.38181 5.07391 4.44985 5C4.51993 4.9234 4.60479 4.86177 4.69931 4.81881C4.79382 4.77584 4.89606 4.75244 4.99985 4.75H19C19.1029 4.74977 19.2046 4.7707 19.2991 4.81148C19.3935 4.85226 19.4785 4.91202 19.5488 4.98704C19.6192 5.06207 19.6733 5.15077 19.7079 5.24761C19.7426 5.34446 19.7569 5.44739 19.75 5.55L18.88 19.39C18.8317 20.1638 18.4905 20.8902 17.9258 21.4214C17.3611 21.9527 16.6153 22.249 15.84 22.25ZM5.83986 6.25L6.60987 19.3C6.63531 19.6935 6.80978 20.0625 7.09775 20.3319C7.38573 20.6013 7.76555 20.7508 8.15989 20.75H15.84C16.2336 20.7485 16.6121 20.5982 16.8996 20.3292C17.1871 20.0603 17.3622 19.6927 17.39 19.3L18.2 6.3L5.83986 6.25Z"
                      fill="#0066BE"
                    />
                    <path
                      d="M20.9998 6.25H2.99999C2.80108 6.25 2.61032 6.17098 2.46967 6.03033C2.32902 5.88968 2.25 5.69891 2.25 5.5C2.25 5.30109 2.32902 5.11032 2.46967 4.96967C2.61032 4.82902 2.80108 4.75 2.99999 4.75H20.9998C21.1987 4.75 21.3895 4.82902 21.5301 4.96967C21.6708 5.11032 21.7498 5.30109 21.7498 5.5C21.7498 5.69891 21.6708 5.88968 21.5301 6.03033C21.3895 6.17098 21.1987 6.25 20.9998 6.25Z"
                      fill="#0066BE"
                    />
                    <path
                      d="M15 6.25009H9C8.80189 6.2475 8.61263 6.16765 8.47253 6.02755C8.33244 5.88745 8.25259 5.69819 8.25 5.50007V3.70004C8.26268 3.18685 8.47219 2.69818 8.83518 2.33519C9.19816 1.9722 9.68682 1.76268 10.2 1.75H13.8C14.3217 1.76305 14.8177 1.97951 15.182 2.35319C15.5463 2.72686 15.7502 3.22815 15.75 3.75004V5.50007C15.7474 5.69819 15.6676 5.88745 15.5275 6.02755C15.3874 6.16765 15.1981 6.2475 15 6.25009ZM9.75 4.75006H14.25V3.75004C14.25 3.63069 14.2026 3.51623 14.1182 3.43184C14.0338 3.34744 13.9193 3.30003 13.8 3.30003H10.2C10.0807 3.30003 9.96619 3.34744 9.8818 3.43184C9.79741 3.51623 9.75 3.63069 9.75 3.75004V4.75006Z"
                      fill="#0066BE"
                    />
                    <path
                      d="M15 18.25C14.8019 18.2474 14.6126 18.1676 14.4725 18.0275C14.3324 17.8874 14.2526 17.6981 14.25 17.5V9.5C14.25 9.30109 14.329 9.11032 14.4697 8.96967C14.6103 8.82902 14.8011 8.75 15 8.75C15.1989 8.75 15.3897 8.82902 15.5303 8.96967C15.671 9.11032 15.75 9.30109 15.75 9.5V17.5C15.7474 17.6981 15.6676 17.8874 15.5275 18.0275C15.3874 18.1676 15.1981 18.2474 15 18.25Z"
                      fill="#0066BE"
                    />
                    <path
                      d="M9 18.25C8.80189 18.2474 8.61263 18.1676 8.47253 18.0275C8.33244 17.8874 8.25259 17.6981 8.25 17.5V9.5C8.25 9.30109 8.32902 9.11032 8.46967 8.96967C8.61032 8.82902 8.80109 8.75 9 8.75C9.19891 8.75 9.38968 8.82902 9.53033 8.96967C9.67098 9.11032 9.75 9.30109 9.75 9.5V17.5C9.74741 17.6981 9.66756 17.8874 9.52747 18.0275C9.38737 18.1676 9.19811 18.2474 9 18.25Z"
                      fill="#0066BE"
                    />
                    <path
                      d="M12 18.25C11.8019 18.2474 11.6126 18.1676 11.4725 18.0275C11.3324 17.8874 11.2526 17.6981 11.25 17.5V9.5C11.25 9.30109 11.329 9.11032 11.4697 8.96967C11.6103 8.82902 11.8011 8.75 12 8.75C12.1989 8.75 12.3897 8.82902 12.5303 8.96967C12.671 9.11032 12.75 9.30109 12.75 9.5V17.5C12.7474 17.6981 12.6676 17.8874 12.5275 18.0275C12.3874 18.1676 12.1981 18.2474 12 18.25Z"
                      fill="#0066BE"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
        <div>
          {highlightData?.loading ? (
            <></>
          ) : highlightData?.error ? (
            <>No data found</>
          ) : !highlightData?.data?.length ? (
            <>No data found</>
          ) : (
            <div className="onesource-table">
              <h5>
                The order of the highlights will be reflected in the R&D library
                on the Docintel app
              </h5>
              {liveHighlightData.length ? (
                <div className={`onesource-common-table `}>
                  <CommonTable
                    className="highlight-visible"
                    data={liveHighlightData || []}
                    setData={setLiveHighlightData}
                    actionStatus={actionStatus}
                    isLive={true}
                    dragable={true}
                    setTrigger={setTrigger}
                    highlightData={highlightData}
                    setHighlightData={setHighlightData}
                  ></CommonTable>
                </div>
              ) : null}
              {offlineHighlightData.length ? (
                <div className={`second-table`}>
                  <div className="onesource-common-table">
                  <CommonTable
                    className="highlight-hidden"
                    data={offlineHighlightData || []}
                    setData={setOfflineHighlightData}
                    actionStatus={actionStatus}
                    isLive={false}
                    dragable={false}
                    setTrigger={setTrigger}
                    highlightData={highlightData}
                    setHighlightData={setHighlightData}
                  ></CommonTable>
                </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </Col>
  );
};

const CommonTable = ({
  data,
  setData,
  actionStatus,
  isLive,
  dragable,
  setTrigger,
  highlightData,
  setHighlightData,
}) => {
  const navigate = useNavigate();
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState({
    status: false,
    id: null,
  });
  const [showSuccessModal, setShowSuccessModal] = useState({
    status: false,
    success: false,
  });

  const handleDrop = async (index) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const reordered = [...data];
    const [moved] = reordered.splice(draggedIndex, 1);
    reordered.splice(index, 0, moved);
    const drag_item = data[draggedIndex]?.id;
    const drop_item = data[index]?.id;
    const updated = reordered.map((item, i) => ({
      ...item,
      position: `${i + 1}`,
    }));
    setData(updated);
    setDraggedIndex(null);
    try {
      await postData(
        ENDPOINT.SWAP_HIGHLIGHT,
        { drag_item, drop_item },
        {
          headers: {
            frontendid: localStorage.getItem("user_id"),
            Token: localStorage.getItem("user_id"),
            created_by: localStorage.getItem("user_id"),
          },
        },
      );
    } catch (error) {
      console.error("Error while sending drag/drop update:", error);
    }
  };
  const handleDragOver = (e) => e.preventDefault();

  const handleDragStart = (index) => setDraggedIndex(index);

  const handleLiveToggle = async (e, id) => {
    try {
      let count = 0;
      if (e?.target?.checked) {
        highlightData?.data?.map((item) => {
          if (item.live_status) count++;
        });
        if (count >= 3) {
          toast.info("You can't make more than 3 highlight live at a time");
          e.target.checked = false;
          return;
        }
      }

      loader("show");
      const data = await getData(
        ENDPOINT.MAKE_LIVE_HIGHLIGHT + "/" + id,
        {
          headers: {
            frontendid: localStorage.getItem("user_id"),
            Token: localStorage.getItem("user_id"),
            created_by: localStorage.getItem("user_id"),
          },
        },
      );
      if (data?.status === 200) {
        let tempData = highlightData.data;
        tempData = tempData.filter((item) => item.id !== id);
        tempData.push({
          ...highlightData?.data?.filter((item) => item.id === id)[0],
          live_status: e?.target?.checked ? 1 : 0,
        });
        setHighlightData((prev) => ({ ...prev, data: tempData }));
      }
    } catch (err) {
      console.log("failed while live toggle : ", err);
      toast.error("Failed to change the status of the highlight");
    } finally {
      loader("hide");
    }
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal({ status: false, id: null });
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal({ status: false, success: false });
    setTrigger((prev) => prev + 1);
  };

  const handleDeleteClick = async (e) => {
    e.preventDefault();
    try {
      loader("show");
      const data = await deleteData(
        ENDPOINT.DELETE_HIGHLIGHT + "/" + showDeleteModal.id,
        {
          headers: {
            frontendid: localStorage.getItem("user_id"),
            Token: localStorage.getItem("user_id"),
            created_by: localStorage.getItem("user_id"),
          },
        },
      );
      if (data.status === 200) {
        setShowDeleteModal({ status: false, id: null });
        setShowSuccessModal({ status: true, success: true });
      }
    } catch (err) {
      console.log("failed while deletion : ", err);
      toast.error("Failed to delete the highlight");
    } finally {
      loader("hide");
    }
  };

  return (
    <>
      <Table responsive>
        <thead className="sticky-header">
          <tr>
            {dragable && <th
              className={`highlight-${dragable ? "visible" : "hidden"}-0`}
            ></th>}
            <th
              className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?1:0}`}
            ></th>
            <th
              className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?2:1}`}
            ></th>
             {isLive && (
              <>
             <th className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?3:2}`}>
              Uploaded date
            </th>
            <th className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?4:3}`}>
              Views
            </th>
            <th className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?5:4}`}>
              Visibility
            </th>
            </> )}
            <th
              className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?6:5}`}
            ></th>
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr
              key={row.id || rowIndex}
              draggable={dragable}
              onDragStart={() => handleDragStart(rowIndex)}
              onDragOver={handleDragOver}
              onDrop={() => handleDrop(rowIndex)}
              style={dragable ? { cursor: "grab" } : {}}
            >
              {dragable && <td className={`highlight-${dragable ? "visible" : "hidden"}-0`}>
                {" "}
                {dragable && (
                  <>
                    {" "}
                    <span class="drag-icon">
                      <img
                        src="https://informed.pro/componentAssets/images/drag-img.svg"
                        alt=""
                        width="10"
                      />
                    </span>
                    <>{rowIndex + 1}.</>
                  </>
                )}
              </td>}
              <td className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?1:0}`}>
                <div class="poster-img">
                  <img src={row.image} alt="" width="140" />
                </div>
              </td>
              <td className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?2:1}`}>
                <div>
                  {/* {row.attach_content ? <div class="title">Article</div>:null} */}
                  <div class="heading">{row.heading}</div>
                  {/* <div class="sub-heading">{row.sub_heading}</div> */}
                </div>
              </td>
              <td
                className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?3:2}`}
                dangerouslySetInnerHTML={{ __html: row.uploaded_at }}
              ></td>
              <td className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?4:3}`}>
                {row.totalUniqueViews || 0}{" "}
                <img
                  height={10}
                  width={20}
                  src={path_image + "views-img.svg"}
                />
              </td>
              <td className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?5:4}`}>
                <div className="toggle-switch">
                  <span>Hidden</span>
                  <Form.Check
                    inline
                    label="Visible"
                    name="group1"
                    type="checkbox"
                    defaultChecked={isLive}
                    onChange={(e) => handleLiveToggle(e, row.id)}
                  />
                </div>
              </td>
              <td className={`highlight-${dragable ? "visible" : "hidden"}-${dragable?6:5}`}>
                {actionStatus === "delete" ? (
                  <button
                    type="button"
                    class="dlt_btn btn btn-primary"
                    onClick={() =>
                      setShowDeleteModal({ status: true, id: row?.id })
                    }
                  >
                    <img
                      src="https://informed.pro/componentAssets/images/delete.svg"
                      alt="delete"
                      width="16"
                    />
                  </button>
                ) : actionStatus === "edit" ? (
                  <button
                    type="button"
                    class="dlt_btn edit btn btn-primary"
                    onClick={() =>
                      navigate("/create-edit-highlight", {
                        state: {
                          type: "edit",
                          id: row.id,
                          element: row,
                        },
                      })
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.15259 12.8329C2.97037 13.0151 2.84302 13.2448 2.78507 13.4959L1.90302 17.3182C1.72646 18.0833 2.41215 18.7689 3.17722 18.5924L6.99946 17.7103C7.25056 17.6524 7.48033 17.525 7.66255 17.3428L18.0346 6.97075C18.8157 6.1897 18.8157 4.92337 18.0346 4.14232L16.3531 2.46079C15.572 1.67974 14.3057 1.67974 13.5247 2.46079L3.15259 12.8329ZM3.52201 16.9734L4.2386 13.8682L12.2063 5.90046L14.5949 8.2891L6.62724 16.2568L3.52201 16.9734ZM15.6556 7.22844L13.267 4.8398L14.5853 3.52145C14.7806 3.32618 15.0972 3.32618 15.2924 3.52145L16.974 5.20298C17.1692 5.39824 17.1692 5.71483 16.974 5.91009L15.6556 7.22844Z"
                        fill="#ffffff"
                      ></path>
                    </svg>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                      navigate("/preview-highlight", {
                        state: {
                          type: "view",
                          element: row,
                        },
                      })
                    }
                  >
                    View
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal
        className="modal send-confirm registration-popup"
        show={showDeleteModal.status}
        centered
        size="lg"
        onHide={handleDeleteModalClose}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header>
          <button
            type="button"
            className="btn-close"
            onClick={handleDeleteModalClose}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <h4>
            <b>Are you sure you want to delete this highlight?</b>
            This action will permanently remove all collected and tracked data
            associated with it.
          </h4>
          <div className="modal-buttons">
            <button
              type="button"
              className="btn btn-primary btn-bordered"
              onClick={handleDeleteClick}
            >
              Yes Please!
            </button>
            <button
              type="button"
              className="btn btn-primary btn-bordered"
              onClick={handleDeleteModalClose}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal send-confirm registration-popup"
        show={showSuccessModal.status}
        centered
        size="lg"
        onHide={handleSuccessModalClose}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header>
          <button
            type="button"
            className="btn-close"
            onClick={handleSuccessModalClose}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <h4>
            {showSuccessModal.status
              ? "The highlight has been deleted successfully!"
              : "Failed to delete highlight. Please try again"}
          </h4>
          <div className="modal-buttons">
            <button
              type="button"
              className="btn btn-primary btn-bordered"
              onClick={handleSuccessModalClose}
            >
              Ok
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Highlights;
